const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const Apple = () => import(/* webpackChunkName: "apple" */ './view/edit.vue');

export const ROUTE_NAME_APPLE = 'Apple' as const;

export default [
    {
        path: '/app/:appId/apple',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: ROUTE_NAME_APPLE,
                component: Apple,
                meta: { requiresAuth: true }
            }
        ]
    }
];
